import React from 'react';

import { Checkbox } from '../..';

interface Props {
    getToggleAllRowsSelectedProps(): RowSelectionProps;
}

export const CheckboxHeader = ({
    getToggleAllRowsSelectedProps,
}: Props): JSX.Element => {
    const { checked, indeterminate, onChange, title } =
        getToggleAllRowsSelectedProps();

    return (
        <Checkbox
            checked={checked}
            indeterminate={indeterminate}
            onChange={onChange}
            inputId={title}
            label=""
        />
    );
};
